import { t as gsapWithCSS } from "@theme/gsap";
import { t as CustomEase } from "@theme/CustomEase";
//#region frontend/islands/sticky-header.js
gsapWithCSS.registerPlugin(CustomEase);
CustomEase.create("header-in", "M0,0 C0.42,0 1,1 1,1");
CustomEase.create("header-out", "M0,0 C0,0 0.42,1 1,1");
var SCROLL_THRESHOLD = 100;
var REVEAL_THRESHOLD = 160;
var StickyHeader = class extends window.HTMLElement {
	connectedCallback() {
		this.header = document.getElementById("shopify-section-header");
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.scrollDownStart = null;
		this.scrollUpStart = null;
		this.ticking = false;
		this.headerState = null;
		this.onScrollHandler = this.onScroll.bind(this);
		this.anchorClickHandler = this.onAnchorClick.bind(this);
		window.addEventListener("scroll", this.onScrollHandler, false);
		document.addEventListener("click", this.anchorClickHandler);
	}
	onScroll() {
		if (!this.ticking) {
			this.ticking = true;
			window.requestAnimationFrame(() => {
				this.processScroll();
				this.ticking = false;
			});
		}
	}
	processScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
		const scrollingDown = scrollTop > this.currentScrollTop;
		if (scrollingDown && this.scrollDownStart === null) {
			this.scrollDownStart = scrollTop;
			this.scrollUpStart = null;
		} else if (!scrollingDown && this.scrollUpStart === null) {
			this.scrollUpStart = scrollTop;
			this.scrollDownStart = null;
		}
		if (scrollTop <= SCROLL_THRESHOLD) {
			if (this.headerState !== null) this.reset();
		} else if (scrollingDown && this.scrollDownStart !== null && scrollTop - this.scrollDownStart >= 50) {
			if (this.preventHide) return;
			this.scrollDownStart = Infinity;
			if (this.headerState !== "hidden") this.hide();
		} else if (!scrollingDown && this.scrollUpStart !== null && this.scrollUpStart - scrollTop >= REVEAL_THRESHOLD) if (!this.preventReveal) {
			if (this.headerState !== "visible") this.reveal();
		} else {
			window.clearTimeout(this.isScrolling);
			this.isScrolling = setTimeout(() => {
				this.preventReveal = false;
			}, 66);
			if (this.headerState !== "hidden") this.hide();
		}
		this.currentScrollTop = scrollTop;
	}
	hide() {
		this.headerState = "hidden";
		document.documentElement.classList.add("header-hidden");
		this.header.classList.add("sticky");
		gsapWithCSS.to(this.header, {
			top: -this.header.offsetHeight,
			duration: .2,
			ease: "linear",
			overwrite: true
		});
	}
	reveal() {
		this.headerState = "visible";
		document.documentElement.classList.remove("header-hidden");
		this.header.classList.add("sticky");
		gsapWithCSS.to(this.header, {
			top: 0,
			duration: .2,
			ease: "linear",
			overwrite: true
		});
	}
	reset() {
		this.headerState = null;
		document.documentElement.classList.remove("header-hidden");
		if (this.header.style.top !== "") gsapWithCSS.to(this.header, {
			top: 0,
			duration: .2,
			ease: "linear",
			overwrite: true,
			onComplete: () => {
				gsapWithCSS.set(this.header, { clearProps: "top" });
				this.header.classList.remove("sticky");
			}
		});
		else {
			gsapWithCSS.killTweensOf(this.header);
			this.header.classList.remove("sticky");
		}
	}
	onAnchorClick(e) {
		const anchor = e.target.closest("a[href^=\"#\"]");
		if (!anchor) return;
		const id = anchor.getAttribute("href").slice(1);
		if (!id) return;
		const target = document.getElementById(id);
		if (!target) return;
		const targetTop = target.getBoundingClientRect().top + window.scrollY;
		const scrollingUp = targetTop < window.scrollY;
		const scrollingDown = targetTop > window.scrollY;
		const headerIsHidden = document.documentElement.classList.contains("header-hidden");
		const headerIsShowing = this.header.classList.contains("sticky") && !headerIsHidden;
		if (scrollingUp) document.documentElement.classList.remove("header-hidden");
		else if (scrollingDown && headerIsShowing) document.documentElement.classList.add("header-hidden");
	}
	disconnectedCallback() {
		window.removeEventListener("scroll", this.onScrollHandler);
		document.removeEventListener("click", this.anchorClickHandler);
		gsapWithCSS.killTweensOf(this.header);
	}
};
window.customElements.define("sticky-header", StickyHeader);
//#endregion
